"use client";
import { createContext, useContext, useEffect, useState } from "react";
import Script from "next/script";

export const reportContext = createContext(false);

export const ReportContext = ({ children }) => {
  const [loaded, setLoaded] = useState(false);
  return (
    <reportContext.Provider value={loaded}>
      {children}
      <Script
        src={`https://static.taocheche.com/taoche-c/lib/ga/index.min.js?v=${new Date().getTime()}`}
        onLoad={() => {
          window.TC.GA.yiche({
            businessType: "taoche",
          }).then(() => {
            setLoaded(true);
          });
        }}
      ></Script>
    </reportContext.Provider>
  );
};

export const Report = ({ page_id }) => {
  const loaded = useContext(reportContext);
  useEffect(() => {
    if (loaded) {
      console.info(page_id);
      window.$SDK_ALL.sendPage({
        data: {
          page_id,
        },
      });
    }
  }, [loaded, page_id]);

  return <></>;
};
